export const daysArray = Array.from({ length: 31 }, (_item, i) => {
    return {
        value: i < 9 ? `0${i + 1}` : (i + 1).toString(),
        label: (i + 1).toString(),
    };
});
export const monthsArray = (translate) => Array.from({ length: 12 }, (_item, i) => {
    const index = `${i + 1}`.padStart(2, "0");
    return {
        value: index,
        label: translate(`month.${index}`),
    };
});
const DEFAULT_MIN_AGE = 18;
const currentYear = new Date().getFullYear();
export const yearsArray = (minAgeToRegister) => {
    const minAge = parseInt(minAgeToRegister, 10) || DEFAULT_MIN_AGE;
    return customYearsArray(currentYear - 1899, -minAge);
};
export const customYearsArray = (rangeMinYear, rangeMaxYear) => {
    const yearsArray = [];
    for (let i = currentYear + rangeMaxYear; i > currentYear - rangeMinYear; i--) {
        yearsArray.push({ value: i.toString(), label: i.toString() });
    }
    return yearsArray;
};
export const getNewDaysArray = (numberOfDays) => daysArray.slice(0, numberOfDays);
//# sourceMappingURL=selectOptions.js.map